export default function ThreeDotsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12.25" cy="7.25" r="1.25" fill="#2D3643" />
      <circle cx="12.25" cy="12.25" r="1.25" fill="#2D3643" />
      <circle cx="12.25" cy="17.25" r="1.25" fill="#2D3643" />
    </svg>
  );
}
